import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=720827a8&scoped=true"
import script from "./Paginate.vue?vue&type=script&lang=js"
export * from "./Paginate.vue?vue&type=script&lang=js"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=720827a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720827a8",
  null
  
)

export default component.exports